// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"d46a9f44","276":"50cf5862","386":"6743cbee","409":"fe0db299","736":"d9d2e81b","915":"9cfa17ba","987":"0df40504"}[chunkId] + ".chunk.css";
};